import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import _merge from 'lodash/merge';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}
const start = () => {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.error(err));
};

if (environment.name !== 'dev') {
	fetch('/environment-config/config.json')
		.then(async (res) => {
			const config = await res.json();
			_merge(environment, config);
			start();
		})
		.catch((e) => {
			console.error(`No configuration found\n${e}`);
		});
} else {
	start();
}
